'use client'

import { ChevronRight } from '@patrianna-icons/material-icons'
import Link from 'next/link'

import ROUTES from 'config/routes.json'
import useCleanBackUrl from 'src/hooks/useCleanBackUrl'
import EXTERNAL_LINKS from 'temp/externalLinks.json'

import classes from '../../styles.module.scss'

const allLinks = [
  {
    title: 'Terms of Use',
    href: ROUTES.TERMS,
    target: '_self',
  },
  {
    title: 'Sweepstakes Rules',
    href: ROUTES.SWEEPSTAKE_RULES,
    target: '_self',
    SCmode: true,
  },
  {
    title: 'Privacy Policy',
    href: ROUTES.PRIVACY,
    target: '_self',
  },
  {
    title: 'Cookie Policy',
    href: ROUTES.COOKIE_POLICY,
    target: '_self',
  },
  {
    title: 'Data Privacy Request Form',
    href: EXTERNAL_LINKS.privacyRequestFormLink,
    target: '_blank',
  },
  {
    title: 'Player Safety',
    href: ROUTES.RESPONSIBLE_PLAY,
    target: '_self',
  },
]
const getLinks = (isSCUser: boolean) => {
  return allLinks.filter(({ SCmode }) => {
    return isSCUser || !SCmode
  })
}

function LegalsLinks({ isSCUser = false }) {
  const cleanBackUrl = useCleanBackUrl()
  const links = getLinks(isSCUser)

  return (
    <>
      {links.map((link) => {
        const isInternal = typeof link.href === 'string' && link.href.startsWith('/')
        const href = isInternal ? `${link.href}?back=${encodeURIComponent(cleanBackUrl)}` : link.href

        return (
          <Link href={href} key={link.title} target={link.target} prefetch={false}>
            <span>{link.title}</span>
            <ChevronRight className={classes.iconArrow} />
          </Link>
        )
      })}
    </>
  )
}

export default LegalsLinks
